<template>
  <div class="hire-us">
    <p class="header">
      Hire us
    </p>
    <p class="desc gt-xs">
      We develop software for fintech companies used by thousands of users all around
    </p>
    <form>
      <div class="input-row" :class="$v.email.$error ? 'has-error' : ''">
        <input type="email"
               v-model.trim="email"
               placeholder="Your e-mail address"
               @blur="$v.email.$touch"
        />
        <div class="error-msg">
          Wrong email format
        </div>
      </div>
      <div class="input-row" :class="$v.subject.$error ? 'has-error' : ''">
        <input v-model.trim="subject"
               placeholder="Subject"
               @blur="$v.subject.$touch"
        />
        <div class="error-msg">
          Subject is required
        </div>
      </div>
      <div class="input-row" :class="$v.message.$error ? 'has-error' : ''">
          <textarea v-model.trim="message"
                    placeholder="Create your message"
                    @blur="$v.message.$touch"
                    rows="5"
          ></textarea>
        <div class="error-msg">
          Message is required
        </div>
      </div>
      <div class="btn-row row justify-end">
        <ButtonCTA @click="submit" :color="viewport.xs ? 'white' : 'green'">
          Hire us
        </ButtonCTA>
      </div>
    </form>
  </div>
</template>

<script>
import { validationMixin } from 'vuelidate';
import { required, email } from 'vuelidate/lib/validators';
import { mapState } from 'vuex';


export default {
  name: 'HireUs',
  mixins: [validationMixin],
  data() {
    return {
      email: '',
      message: '',
      subject: '',
    };
  },
  computed: {
    ...mapState('viewport', ['viewport']),
  },
  methods: {
    submit() {
      // eslint-disable-next-line
      const { email, message, subject } = this;
      this.$v.$touch();
      if (this.$v.$error) {
        return;
      }
      window.location.href = `mailto:${email}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(message)}`;
    },
  },
  validations: {
    email: {
      required,
      email,
    },
    message: {
      required,
    },
    subject: {
      required,
    },
  },
};
</script>

<style lang="stylus" scoped>
  @import '../../styles/variables';

  .hire-us {
    padding-left: 40px;
    padding-right: 40px;
    padding-top: 45px;
    padding-bottom: 50px;
    background: #4cb06a;
    color: white;
    max-width: 580px;
    margin: 0 auto;
    transition: padding 0.3s, margin 0.3s;
    *{
      transition: padding 0.3s, margin 0.3s;
    }
  }

  .header{
    font-family: 'Dosis', sans-serif;
    font-size: 24px;
    line-height: normal;
    font-weight: 600;
    color: white;
    margin-bottom: 20px;
  }


  input, textarea{
    background: #409d5c;
    border: 0;
    margin: 0;
    outline: none;
    width: 100%;
    padding: 12px 15px;
    font-size: 14px;
    color: white;
    &::placeholder{
      color: #ADD8BA;
    }
  }

  textarea{
    resize: vertical;
  }

  .input-row{
    padding-bottom: 25px;
    position: relative;

    .error-msg{
      position: absolute;
      padding-left: 15px;
      bottom: 8px;
      font-size: 12px;
      color: #fff;
      opacity: 0;
      transition: opacity 0.3s;
    }

    &.has-error{
      .error-msg{
        opacity: 1;
      }
    }
  }

  .btn-row{
    padding-top: 10px;
  }


  @media(min-width: $breakpoint-sm-min) {
    .hire-us {
      padding: 65px;
    }
    .header{
      font-size: 30px;
      line-height: 38px;
      margin-bottom: 15px;
    }
    .desc{
      font-size: 16px;
      color: #FFFFFF;
      line-height: 26px;
      font-weight: 200;
      margin-bottom: 35px;
    }
  }

  @media(min-width: $breakpoint-md-min) {
    .hire-us{
      padding: 45px 80px;
      margin: 0;
    }
  }
  @media(min-width: $breakpoint-lg-min) {
    .hire-us{
      padding: 80px 100px;
      padding-bottom: 80px;
    }
    .header{
      font-size: 40px;
      line-height: 50px;
    }
    .desc{
      font-size: 18px;
      line-height: 33px;
    }
  }
</style>
